var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvailability = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 31,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  clipPath: "url(#Availability_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.875 18.125c0 .825.675 1.5 1.5 1.5h.75c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5h-.75.75c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5h-.75c-.825 0-1.5.675-1.5 1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.875 7.625H7.125a.75.75 0 0 0-.75.75v13.5c0 .414.336.75.75.75h15.75a.75.75 0 0 0 .75-.75v-13.5a.75.75 0 0 0-.75-.75M6.375 11.375h17.25M20.625 5.375v3.75M9.375 5.375v3.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.375 19.625v-6l-1.5 1.5"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Availability_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6 5h18v18H6z"
})))));
export default SvgAvailability;